export const Constants = {
    TEST_VARIANT: "TEST_VARIANT",
    TEST_ANSWER: "TEST_ANSWER"
}

export const DictionaryTypes = [
    {
        id: "TYPE_ARCH",
        title: "Архаизмы",
        description: "АРХАИЗМНАР (АРХАИЗМЫ)"
    },
    {
        id: "TYPE_HIST",
        title: "Историзмы",
        description: "ИСТОРИЗМНАР (ИСТОРИЗМЫ)"
    },
    {
        id: "TYPE_OBR",
        title: "Образная лексика",
        description: "ДЬҮҺҮННҮҮР ТЫЛЛАР (ОБРАЗНАЯ ЛЕКСИКА)"
    },
    {
        id: "TYPE_RUS",
        title: "Заимствованные слова",
        description: "НУУЧЧА ТЫЛЫТТАН КИИРИИ ТЫЛЛАР (ЗАИМСТВОВАННЫЕ ИЗ РУССКОГО ЯЗЫКА СЛОВА)"
    },
    {
        id: "TYPE_FRAZ",
        title: "Фразеологизмы",
        description: "СОМОҔО ДОМОХТОР (ФРАЗЕОЛОГИЗМЫ)"
    },
    {
        id: "TYPE_POSL",
        title: "Пословицы и поговорки",
        description: "ӨС ХОҺООННОРО (ПОСЛОВИЦЫ И ПОГОВОРКИ)"
    },
    {
        id: "TYPE_SRAV",
        title: "Сравнения",
        description: "ТЭҤНЭБИЛЛЭР (СРАВНЕНИЯ)"
    },
    {
        id: "TYPE_EPICH",
        title: "Эпические формулы",
        description: "КҮННЭЭҔИ ОЛОХХО ТУТТУОХХА СӨПТӨӨХ ЭПИЧЕСКЭЙ ФОРМУЛАЛАР (ЭПИЧЕСКИЕ ФОРМУЛЫ ДЛЯ УПОТРЕБЛЕНИЯ В ПОВСЕДНЕВНОЙ РЕЧИ)"
    },
]